import makeStyles from '@mui/styles/makeStyles';

const useEstimatedGenerationStyles = makeStyles({
  root: {}
});

export default useEstimatedGenerationStyles;
